import { MessageCircle, ArrowRight } from 'lucide-react';

// Gate 33 WhatsApp Community — single source of truth for the invite link.
export const WHATSAPP_COMMUNITY_URL = 'https://chat.whatsapp.com/EMMoeIfWQcgIhuH4Dz49mE';

// ============================================================
// Editorial section — used on /enrollment and /careers
// Premium cream block with gold accents, matches the Gate 33 look.
// ============================================================
export const WhatsAppCommunityBlock = ({
  eyebrow = 'Stay close',
  title = 'Join the Gate 33 community.',
  body = "Where private aviation crew exchange operator news, openings, and the small details no airline ever taught them. Curated, quiet, and useful.",
  ctaLabel = 'Join the community on WhatsApp',
}) => (
  <section
    data-testid="whatsapp-community-block"
    className="bg-[#FDFBF7] section-padding border-y border-[#E5E0D8]"
  >
    <div className="container-custom max-w-4xl text-center">
      <div className="w-14 h-14 mx-auto mb-7 border border-[#C5A880] flex items-center justify-center">
        <MessageCircle size={22} className="text-[#C5A880]" strokeWidth={1.5} />
      </div>
      <span className="overline inline-block mb-5">{eyebrow}</span>
      <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight mb-6 text-[#0F0F0F]">
        {title}
      </h2>
      <p className="text-[#5A5A5A] leading-relaxed max-w-2xl mx-auto mb-10">
        {body}
      </p>
      <a
        href={WHATSAPP_COMMUNITY_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-community-cta"
        className="inline-flex items-center gap-2 bg-[#0F0F0F] text-[#FDFBF7] px-10 py-4 uppercase tracking-[0.15em] text-xs font-semibold hover:bg-[#C5A880] hover:text-[#0F0F0F] transition-all duration-300"
      >
        {ctaLabel} <ArrowRight size={14} />
      </a>
      <p className="text-xs uppercase tracking-[0.18em] text-[#9A9A9A] mt-5">
        Free · Read-only by default · No spam
      </p>
    </div>
  </section>
);

// ============================================================
// Thin sitewide banner — sits just above the Footer.
// Single line, gold accent, hover gold-to-white.
// ============================================================
export const WhatsAppCommunityRibbon = () => (
  <div
    data-testid="whatsapp-community-ribbon"
    className="bg-[#0F0F0F] border-t border-[#C5A880]/30"
  >
    <a
      href={WHATSAPP_COMMUNITY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-community-ribbon-cta"
      className="container-custom flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 py-4 text-center group"
    >
      <span className="inline-flex items-center gap-2.5 text-[#D6D2CA] text-sm">
        <MessageCircle size={14} className="text-[#C5A880]" strokeWidth={1.8} />
        Join the Gate 33 community on WhatsApp — operator news, openings & insights.
      </span>
      <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.15em] font-semibold text-[#C5A880] group-hover:text-[#FDFBF7] transition-colors">
        Join now <ArrowRight size={12} />
      </span>
    </a>
  </div>
);

export default WhatsAppCommunityBlock;
